/**
 * A Mutex lock for {@link Promise} to ensure doing some action one at a time
 * @returns a mutex locker
 */
function mutex() {
    var promise;
    return {
        lock: function (action) {
            if (!promise) {
                promise = action();
            }
            return promise.finally(function () {
                promise = undefined;
            });
        },
    };
}
export default mutex;
//# sourceMappingURL=mutex.js.map